var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9061 2.5116C15.6483 0.613161 12.16 0.898317 9.99988 3.09754C7.83973 0.898317 4.35144 0.609254 2.09363 2.5116C-0.843868 4.98425 -0.41418 9.0155 1.67957 11.1522L8.53113 18.1327C8.92176 18.5311 9.4452 18.7538 9.99988 18.7538C10.5585 18.7538 11.078 18.535 11.4686 18.1366L18.3202 11.1561C20.41 9.01941 20.8475 4.98816 17.9061 2.5116ZM16.9843 9.83582L10.1327 16.8163C10.0389 16.91 9.96082 16.91 9.86707 16.8163L3.01551 9.83582C1.58973 8.38269 1.30066 5.63269 3.30066 3.9491C4.8202 2.67175 7.16395 2.86316 8.6327 4.35925L9.99988 5.75379L11.3671 4.35925C12.8436 2.85535 15.1874 2.67175 16.6991 3.94519C18.6952 5.62879 18.3983 8.39441 16.9843 9.83582Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyHeart);
export default __webpack_public_path__ + "static/media/empty-heart.caab85b7.svg";
export { ForwardRef as ReactComponent };